var map = {
	"./decidim/avatar-multiuser.png": 24778,
	"./decidim/brands/google.svg": 49093,
	"./decidim/cc-badge.png": 46612,
	"./decidim/decidim-logo.svg": 47096,
	"./decidim/default-avatar.svg": 928,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 22460,
	"./decidim/icons.svg": 80731,
	"./decidim/pattern.png": 96220,
	"./decidim/placeholder-card-g.svg": 96985,
	"./decidim/placeholder-card-l.svg": 92530,
	"./decidim/placeholder.jpg": 76145,
	"./decidim/remixicon.symbol.svg": 63541,
	"./decidim/vendor/leaflet/layers-2x.png": 35796,
	"./decidim/vendor/leaflet/layers.png": 6963,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 92558,
	"./decidim/vendor/leaflet/marker-icon.png": 48309,
	"./decidim/vendor/leaflet/marker-shadow.png": 16986,
	"./decidim/vendor/social-share-button/douban.svg": 41476,
	"./decidim/vendor/social-share-button/email.svg": 59553,
	"./decidim/vendor/social-share-button/facebook.svg": 96039,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 51737,
	"./decidim/vendor/social-share-button/hacker_news.svg": 42065,
	"./decidim/vendor/social-share-button/linkedin.svg": 1601,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 41986,
	"./decidim/vendor/social-share-button/pinterest.svg": 10295,
	"./decidim/vendor/social-share-button/reddit.svg": 16123,
	"./decidim/vendor/social-share-button/telegram.svg": 60542,
	"./decidim/vendor/social-share-button/tumblr.svg": 74173,
	"./decidim/vendor/social-share-button/twitter.svg": 2288,
	"./decidim/vendor/social-share-button/vkontakte.svg": 82174,
	"./decidim/vendor/social-share-button/wechat.svg": 50617,
	"./decidim/vendor/social-share-button/whatsapp.svg": 45761,
	"./decidim/vendor/social-share-button/x.svg": 62633,
	"./decidim/vendor/social-share-button/xing.svg": 50439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4757;